// extracted by mini-css-extract-plugin
module.exports = {"container":"NewRulePopUp_container__7k7Rj","buttonContainer":"NewRulePopUp_buttonContainer__20RXZ"};